import { Model } from "@ofqual/portal-core/core/types";
import { isEnumDeclaration } from "typescript";
import { Attachment } from "./Attachment";

export type PublicEnquiryModel = {
  id: string;
  title: string;
  createdByUpn: string;
  createdByDisplayName: string;
  createdDate: string;
  modifiedDate: string;
  modifiedByDisplayName: string;
  modifiedByUpn: string;
  assignedToUpn: string;
  assignedToDisplayName: string;
  referenceNumber: string;
  category: number;
  contactMethod: number;
  learnerType: number;
  exceptionCircumstances: number;
  year: number;
  status: PublicEnquiryStatus;
  closed: number;
  closedByUpn: string;
  closedDate: string;
  resourceTags: number[];
  nameTitle: string;
  firstName: string;
  lastName: string;
  fullName: string;
  telephone: string;
  email: string;
  dateReceived: string;
  customerTypeId: number;
  directorate: number;
  summaryOfEnquiry: string;
  focusOfEnquiry: number;
  themeOfEnquiry: number;
  slA_DueDate: string;
  slA_ResponseDate: string;
  slA_ResponseType: number;
  centreNumberTypeId: string;
  centreNumber: string;
  centreAddressLine1: string;
  centreAddressLine2: string;
  centreTown: string;

  seriesAndYear: {
    id: string;
    peId: string;
    seriesId: number;
    year: number;
  }[];

  organisation: {
    id: string;
    peId: string;
    organisationId: number;
  }[];

  qualificationType: {
    id: number;
    peId: number;
    qualificationTypeId: number;
  }[];

  subject: {
    id: number;
    peId: string;
    subjectId: number;
  }[];

  canModifyTransferFrom: boolean;
  transferFrom?: number;
  canModifyTransferOwnership: boolean;
  transferOwnership?: number;
  supportingFiles: File[];
  supportingDocuments?: Attachment[];
};

export const fromApiModel = (model: Model): PublicEnquiryModel => {
  return {
    ...model,
  } as PublicEnquiryModel;
};

export const toApiModel = (item: PublicEnquiryModel): Model => {
  return {
    ...item,
  } as Model;
};

export enum MockSLA {
  Overdue = 0,
  Near = 1,
  Far = 2,
}

// What a pain in the ass I want a space in pending lines since the enum is used loads of places instead of using a regular object I tried this
// create the enum as usual but then create a dictionary based on the enum so each element in the enum must
// be defined and then read that where I need to display text, what a faff :-) bn
export enum PublicEnquiryStatus {
  New = 0,
  Open = 1,
  Closed = 2,
  "Pending Lines" = 3,
}

export enum PublicEnquiryResponse {
  CaseNote = 0,
  ResponseCustomer = 1,
  NewInformation = 2,
  OriginalEnquiry = 3,
  LessonsLearnt = 4,
}

type EnumDictionary<T extends string | symbol | number, U> = {
  [K in T]: U;
};

const a: EnumDictionary<PublicEnquiryStatus, string> = {
  [PublicEnquiryStatus.New]: "New",
  [PublicEnquiryStatus.Open]: "Open",
  [PublicEnquiryStatus.Closed]: "Closed",
  [PublicEnquiryStatus["Pending Lines"]]: "Pending Lines",
};

export const PublicEnquiriesState = (value: number): string => {
  return a[value as keyof typeof isEnumDeclaration];
};

export enum CentreType {
  NCN = "NCN",
  NA = "N/A",
  UKPRN = "UKPRN",
}
